export const CLIENT_ID = process.env.REACT_APP_ASANA_CLIENT_ID || '1210078817286780';
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://asana-time-tracking.ashstonestudios.com';
export const REDIRECT_URI = process.env.REACT_APP_ASANA_REDIRECT || 'https://asana-time-tracking.ashstonestudios.com/oauth/callback';
export const EMPLOYEE_API_TOKEN = 'sk_employee_2024_a8f5e2c1b9d4f7a3e6c8b2d1f5a9e4c7';

// Asana workspace members to hide from the user selector (clients, test
// accounts, non-employees). Matched by exact Asana display name.
// Add or remove names here as needed.
export const EXCLUDED_USERS = [
	'daniel@backpack.works',
	'gabriel@backpack.works',
	'leticia@backpack.works',
	'olga@ashstonestudios.com',
	'Graham',
	'Sergey Sedykh',
	'Evgeny Kostin'
	// 'Alexey Shaposhnikov',
	// 'Olga Rafikova'
];
